import clsx from 'clsx';
import { alpha, styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { ReactElement, useState } from 'react';
import NavLinkAdapter from './NavLinkAdapter';
import { useGlobalCore } from '../../core/modules/global';
import useThemeMediaQuery from '../../core/hooks/useThemeMediaQuery';

interface Props {
  title: string;
  subtitle?: string;
  url: string;
  icon: ReactElement;
  nestedLevel?: number;
}

const Root = styled(ListItem)<any>(({ theme, ...props }) => ({
  minHeight: 44,
  width: '100%',
  borderRadius: '6px',
  margin: '0 0 4px 0',
  paddingRight: 16,
  paddingLeft: props.itempadding > 80 ? 80 : props.itempadding,
  paddingTop: 10,
  paddingBottom: 10,
  color: '#B9BDF8', // Color de texto del menú según diseño
  cursor: 'pointer',
  textDecoration: 'none!important',
  '&:hover': {
    color: '#B9BDF8',
  },
  '&.active': {
    color: theme.palette.text.primary, // Color blanco cuando está activo
    backgroundColor:
      theme.palette.mode === 'light'
        ? 'rgba(0, 0, 0, .05)!important'
        : '#B9BDF8!important', // Color para elementos activos según diseño
    pointerEvents: 'none',
    transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
    '& > .fuse-list-item-text-primary': {
      color: 'inherit',
    },
    '& > .fuse-list-item-icon': {
      color: 'inherit',
    },
  },
  '& >.fuse-list-item-icon': {
    marginRight: 16,
    marginLeft: 4,
    color: 'inherit',
  },
  '& > .fuse-list-item-text': {},
}));

const NavItem = (props: Props) => {
  const { url, title, subtitle, icon, nestedLevel = 0 } = props;
  const { closeMobileNarvar } = useGlobalCore();
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
  const itempadding = nestedLevel > 0 ? 38 + nestedLevel * 16 : 16;

  const handleItemClick = () => {
    if (isMobile) {
      closeMobileNarvar();
    }
  };

  const [active] = useState(false);

  return (
    <Root
      button
      component={NavLinkAdapter}
      to={url}
      activeClassName={url ? 'active' : ''}
      className={clsx('fuse-list-item', active && 'active')}
      itempadding={itempadding}
      onClick={handleItemClick}
      role="button"
    >
      <div className="fuse-list-item-icon shrink-0">{icon}</div>

      <ListItemText
        className="fuse-list-item-text"
        primary={title}
        secondary={subtitle}
        classes={{
          primary: 'text-13 font-medium fuse-list-item-text-primary truncate',
          secondary:
            'text-11 font-medium fuse-list-item-text-secondary leading-normal truncate',
        }}
      />
    </Root>
  );
};

export default NavItem;
